module.exports = __webpack_public_path__ + "img/business-phone-card-header.3e35699a.jpg";